import React from 'react';
import {AiOutlineLoading} from 'react-icons/ai'

const Loader = () => {
    return (
        <div className="loader__container">
            <AiOutlineLoading className="loader__l" size="100" />
        </div>
    );
}

export default Loader;
